import { type ComponentPropsWithoutRef, type ReactElement } from 'react';
import type { WithCategoryNavigationMenu } from '@/components/navigation-menu';
import {
    DeferredMobileMenuDropdown,
    NavigationMenuDesktop,
    NavigationMenuMobileToggle,
    NavigationMenuProvider,
} from '@/components/navigation-menu-mega';
import Header, { type HeaderProps } from './index';

type HeaderNavigationSlotProps = Pick<
    HeaderProps,
    'desktopNavigation' | 'mobileNavigationToggle' | 'mobileNavigationMenu'
>;

/** Canonical Header slot wiring for the responsive mega menu. */
// eslint-disable-next-line react-refresh/only-export-components
export function headerNavigationSlots(): HeaderNavigationSlotProps {
    return {
        desktopNavigation: <NavigationMenuDesktop />,
        mobileNavigationToggle: <NavigationMenuMobileToggle />,
        mobileNavigationMenu: <DeferredMobileMenuDropdown />,
    };
}

type HeaderWithNavigationProps = ComponentPropsWithoutRef<typeof WithCategoryNavigationMenu> &
    Omit<HeaderProps, keyof HeaderNavigationSlotProps>;

/** Navigation provider + Header with canonical mega-menu slots — use in `_app` and Storybook. */
export function HeaderWithNavigation({ resolve, defer, ...headerProps }: HeaderWithNavigationProps): ReactElement {
    return (
        <NavigationMenuProvider resolve={resolve} defer={defer}>
            <Header {...headerNavigationSlots()} {...headerProps} />
        </NavigationMenuProvider>
    );
}
